export default __webpack_public_path__ + "157f857614146f2c365d869c8b0ca822.png";